var React = require('react');

function SocialLinkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m99.1769067 37.5c22.6811913 0 28.1195533 14.4653838 28.7557083 33.9359879l.067385 4.3507222v44.2082669l-24.036168.005023-.017976-42.0774799c-.143192-8.7381682-1.411467-18.4138144-12.4908886-18.4138144-11.6461843 0-14.1091405 8.7943761-14.3934665 18.4749454l-.0301683 2.1626109v39.848715h-24.0313326v-80.4759218h23.0787828v10.9742177h.3384695c3.2057894-6.3233593 11.0582812-12.9932729 22.7596544-12.9932729zm-68.6769067 0v82.5h-22.5v-82.5zm-10.5-37.5c8.2755031 0 14.9947953 6.68796408 15 14.9300639 0 8.2420998-6.7192922 15.0699361-15 15.0699361s-15-6.8278363-15-15.0699361c0-8.24209982 6.7192922-14.9300639 15-14.9300639z"}));
}

SocialLinkedin.defaultProps = {"height":"128","viewBox":"0 0 128 128","width":"128"};

module.exports = SocialLinkedin;

SocialLinkedin.default = SocialLinkedin;
